// react_frontend/src/Components/Modules/Accounting/BalanceSheet.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import {
    Box, Typography, Paper, TextField, Button, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Grid, Chip
} from '@mui/material';
import { FaSearch, FaBalanceScale } from 'react-icons/fa';

export default function BalanceSheet() {
    const [assets, setAssets] = useState([]);
    const [liabilities, setLiabilities] = useState([]);
    const [equity, setEquity] = useState([]);
    const [totals, setTotals] = useState({ assets: 0, liabilities: 0, equity: 0, balanced: false });
    const [asOfDate, setAsOfDate] = useState('');

    const fetchBalanceSheet = async () => {
        try {
            const res = await AxiosAuthInstance.get('accounting/reports/balance-sheet', {
                params: { as_of_date: asOfDate }
            });
            setAssets(res.data.assets || []);
            setLiabilities(res.data.liabilities || []);
            setEquity(res.data.equity || []);
            setTotals({
                assets: res.data.total_assets || 0,
                liabilities: res.data.total_liabilities || 0,
                equity: res.data.total_equity || 0,
                balanced: res.data.balanced || false,
            });
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => { fetchBalanceSheet(); }, []);

    const renderSection = (title, items, total, color) => (
        <Box sx={{ mb: 3 }}>
            <Typography variant="h6" fontWeight={700} color={color} sx={{ mb: 1 }}>{title}</Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ bgcolor: `${color}20` }}>
                            <TableCell>Code</TableCell>
                            <TableCell>Account</TableCell>
                            <TableCell align="right">Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.map((item, idx) => (
                            <TableRow key={idx}>
                                <TableCell><code>{item.account_code}</code></TableCell>
                                <TableCell>{item.account_name}</TableCell>
                                <TableCell align="right">{Number(item.balance).toLocaleString()}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow sx={{ bgcolor: `${color}10`, fontWeight: 700 }}>
                            <TableCell colSpan={2}><strong>Total {title}</strong></TableCell>
                            <TableCell align="right"><strong>৳{Number(total).toLocaleString()}</strong></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Balance Sheet" />
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" fontWeight={700} mb={2}>Balance Sheet</Typography>
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <TextField label="As of Date" type="date" value={asOfDate} onChange={(e) => setAsOfDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <Button variant="contained" onClick={fetchBalanceSheet} startIcon={<FaSearch />}>Generate</Button>
                </Box>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        {renderSection('Assets', assets, totals.assets, '#1976d2')}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {renderSection('Liabilities', liabilities, totals.liabilities, '#d32f2f')}
                        {renderSection('Equity', equity, totals.equity, '#7b1fa2')}
                    </Grid>
                </Grid>

                <Box sx={{ p: 3, bgcolor: totals.balanced ? '#e8f5e9' : '#ffebee', borderRadius: 2, textAlign: 'center', mt: 3 }}>
                    <Typography variant="h6" fontWeight={700}><FaBalanceScale style={{ marginRight: 8 }} />Balance Check</Typography>
                    <Typography variant="body1">Assets: ৳{Number(totals.assets).toLocaleString()} = Liabilities + Equity: ৳{Number(totals.liabilities + totals.equity).toLocaleString()}</Typography>
                    <Chip label={totals.balanced ? 'Balanced ✓' : 'Not Balanced ✗'} color={totals.balanced ? 'success' : 'error'} sx={{ mt: 1 }} />
                </Box>
            </Paper>
        </Box>
    );
}